import { useEffect, useRef, useState } from "react";
import { WorkTask } from "../../types/ganttChart";
import labels from "../../utils/labels";
import VisitHoursTimeline from "./VisitHoursTimeline";
import VisitHoursListItem from "./VisitHoursListItem";
import drawerStyles from "../../styles/drawer.module.css";
import LabeledSection from "../UI/LabeledSection";

const VisitHoursWrapper = ({ task }: { task: WorkTask }) => {
  const visitHoursWrapper = useRef<HTMLDivElement>(null);
  const [svgWidth, setSvgWidth] = useState<number>();
  useEffect(() => {
    if (visitHoursWrapper) setSvgWidth(visitHoursWrapper.current?.clientWidth);
  }, [visitHoursWrapper]);
  return (
    <LabeledSection title={labels.visitHours}>
      <div
        ref={visitHoursWrapper}
        className={drawerStyles.visitHoursListWrapper}
      >
        {svgWidth && (
          <section
            style={{ width: svgWidth - 2 * 24, marginLeft: 24 }}
            className={drawerStyles.visitHoursBody}
          >
            <VisitHoursTimeline svgWidth={svgWidth - 24} task={task} />
            <div className="gap-1 flex flex-col">
              <VisitHoursListItem
                start={task.start}
                end={task.end}
                label="Planlagt"
                bgColor={"var(--col-graph-third-2)"}
                borderColor={"var(--col-graph-third-2)"}
                borderType="SOLID"
              />
              <VisitHoursListItem
                start={task.preferredEarliestStart}
                end={task.preferredLatestEnd}
                label="Foretrukne tid"
                bgColor={"var(--col-graph-third)"}
                borderColor={"var(--col-graph-third-1)"}
                borderType="SOLID"
              />
              <VisitHoursListItem
                start={task.earliestStart}
                end={task.latestEnd}
                label="Tilladt tid"
                bgColor={"var(--col-border-primary)"}
                borderColor={"var(--col-graph-first-1)"}
                borderType="DASHED"
              />
            </div>
          </section>
        )}
      </div>
    </LabeledSection>
  );
};

export default VisitHoursWrapper;
